/**
 * ehr#741 (Chase 10-31 point 2): every diagnosis code the EHR offers (the progress note's Diagnosis
 * window, the New Client note's Diagnosis codes card, authorizations). The billable
 * behavioral-health ICD-10-CM codes (April 2026 code set) the Treatment Plan module's library holds
 * (tp-credify public/index.html dxCodes, V508), in code order. Generated from that list: regenerate
 * it rather than editing by hand.
 */
export const ICD10_CATALOG = [
    ['F01.50', 'Vascular dementia, unspecified severity, without behavioral disturbance'],
    ['F01.511', 'Vascular dementia, unspecified severity, with agitation'],
    ['F01.518', 'Vascular dementia, unspecified severity, with other behavioral disturbance'],
    ['F01.52', 'Vascular dementia, unspecified severity, with psychotic disturbance'],
    ['F01.53', 'Vascular dementia, unspecified severity, with mood disturbance'],
    ['F01.54', 'Vascular dementia, unspecified severity, with anxiety'],
    [
        'F02.80',
        'Dementia in other diseases classified elsewhere, unspecified severity, without behavioral disturbance',
    ],
    [
        'F02.811',
        'Dementia in other diseases classified elsewhere, unspecified severity, with agitation',
    ],
    [
        'F02.818',
        'Dementia in other diseases classified elsewhere, unspecified severity, with other behavioral disturbance',
    ],
    [
        'F02.82',
        'Dementia in other diseases classified elsewhere, unspecified severity, with psychotic disturbance',
    ],
    [
        'F02.83',
        'Dementia in other diseases classified elsewhere, unspecified severity, with mood disturbance',
    ],
    ['F02.84', 'Dementia in other diseases classified elsewhere, unspecified severity, with anxiety'],
    ['F03.90', 'Unspecified dementia, unspecified severity, without behavioral disturbance'],
    ['F03.911', 'Unspecified dementia, unspecified severity, with agitation'],
    ['F03.918', 'Unspecified dementia, unspecified severity, with other behavioral disturbance'],
    ['F03.92', 'Unspecified dementia, unspecified severity, with psychotic disturbance'],
    ['F03.93', 'Unspecified dementia, unspecified severity, with mood disturbance'],
    ['F03.94', 'Unspecified dementia, unspecified severity, with anxiety'],
    ['F04', 'Amnestic disorder due to known physiological condition'],
    ['F05', 'Delirium due to known physiological condition'],
    ['F06.0', 'Psychotic disorder with hallucinations due to known physiological condition'],
    ['F06.1', 'Catatonic disorder due to known physiological condition'],
    ['F06.2', 'Psychotic disorder with delusions due to known physiological condition'],
    ['F06.30', 'Mood disorder due to known physiological condition, unspecified'],
    ['F06.31', 'Mood disorder due to known physiological condition, with depressive features'],
    [
        'F06.32',
        'Mood disorder due to known physiological condition, with major depressive-like episode',
    ],
    ['F06.33', 'Mood disorder due to known physiological condition, with manic features'],
    ['F06.34', 'Mood disorder due to known physiological condition, with mixed features'],
    ['F06.4', 'Anxiety disorder due to known physiological condition'],
    [
        'F06.70',
        'Mild neurocognitive disorder due to known physiological condition without behavioral disturbance',
    ],
    [
        'F06.71',
        'Mild neurocognitive disorder due to known physiological condition with behavioral disturbance',
    ],
    ['F06.8', 'Other specified mental disorders due to known physiological condition'],
    ['F07.0', 'Personality change due to known physiological condition'],
    ['F07.81', 'Postconcussional syndrome'],
    ['F07.89', 'Other personality and behavioral disorders due to known physiological condition'],
    ['F07.9', 'Unspecified personality and behavioral disorder due to known physiological condition'],
    ['F09', 'Unspecified mental disorder due to known physiological condition'],
    ['F10.10', 'Alcohol abuse, uncomplicated'],
    ['F10.11', 'Alcohol abuse, in remission'],
    ['F10.130', 'Alcohol abuse with withdrawal, uncomplicated'],
    ['F10.14', 'Alcohol abuse with alcohol-induced mood disorder'],
    ['F10.159', 'Alcohol abuse with alcohol-induced psychotic disorder, unspecified'],
    ['F10.180', 'Alcohol abuse with alcohol-induced anxiety disorder'],
    ['F10.20', 'Alcohol dependence, uncomplicated'],
    ['F10.21', 'Alcohol dependence, in remission'],
    ['F10.230', 'Alcohol dependence with withdrawal, uncomplicated'],
    ['F10.231', 'Alcohol dependence with withdrawal delirium'],
    ['F10.232', 'Alcohol dependence with withdrawal with perceptual disturbance'],
    ['F10.239', 'Alcohol dependence with withdrawal, unspecified'],
    ['F10.24', 'Alcohol dependence with alcohol-induced mood disorder'],
    ['F10.259', 'Alcohol dependence with alcohol-induced psychotic disorder, unspecified'],
    ['F10.280', 'Alcohol dependence with alcohol-induced anxiety disorder'],
    ['F10.90', 'Alcohol use, unspecified, uncomplicated'],
    ['F10.91', 'Alcohol use, unspecified, in remission'],
    ['F10.930', 'Alcohol use, unspecified with withdrawal, uncomplicated'],
    ['F10.94', 'Alcohol use, unspecified with alcohol-induced mood disorder'],
    ['F10.959', 'Alcohol use, unspecified with alcohol-induced psychotic disorder, unspecified'],
    ['F10.980', 'Alcohol use, unspecified with alcohol-induced anxiety disorder'],
    ['F10.99', 'Alcohol use, unspecified with unspecified alcohol-induced disorder'],
    ['F11.10', 'Opioid abuse, uncomplicated'],
    ['F11.11', 'Opioid abuse, in remission'],
    ['F11.13', 'Opioid abuse with withdrawal'],
    ['F11.14', 'Opioid abuse with opioid-induced mood disorder'],
    ['F11.20', 'Opioid dependence, uncomplicated'],
    ['F11.21', 'Opioid dependence, in remission'],
    ['F11.23', 'Opioid dependence with withdrawal'],
    ['F11.24', 'Opioid dependence with opioid-induced mood disorder'],
    ['F11.90', 'Opioid use, unspecified, uncomplicated'],
    ['F11.91', 'Opioid use, unspecified, in remission'],
    ['F11.93', 'Opioid use, unspecified with withdrawal'],
    ['F11.94', 'Opioid use, unspecified with opioid-induced mood disorder'],
    ['F12.10', 'Cannabis abuse, uncomplicated'],
    ['F12.11', 'Cannabis abuse, in remission'],
    ['F12.13', 'Cannabis abuse with withdrawal'],
    ['F12.159', 'Cannabis abuse with psychotic disorder, unspecified'],
    ['F12.180', 'Cannabis abuse with cannabis-induced anxiety disorder'],
    ['F12.20', 'Cannabis dependence, uncomplicated'],
    ['F12.21', 'Cannabis dependence, in remission'],
    ['F12.23', 'Cannabis dependence with withdrawal'],
    ['F12.259', 'Cannabis dependence with psychotic disorder, unspecified'],
    ['F12.280', 'Cannabis dependence with cannabis-induced anxiety disorder'],
    ['F12.90', 'Cannabis use, unspecified, uncomplicated'],
    ['F12.91', 'Cannabis use, unspecified, in remission'],
    ['F12.93', 'Cannabis use, unspecified with withdrawal'],
    ['F12.959', 'Cannabis use, unspecified with psychotic disorder, unspecified'],
    ['F12.980', 'Cannabis use, unspecified with anxiety disorder'],
    ['F13.10', 'Sedative, hypnotic or anxiolytic abuse, uncomplicated'],
    ['F13.11', 'Sedative, hypnotic or anxiolytic abuse, in remission'],
    ['F13.130', 'Sedative, hypnotic or anxiolytic abuse with withdrawal, uncomplicated'],
    [
        'F13.14',
        'Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced mood disorder',
    ],
    [
        'F13.180',
        'Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced anxiety disorder',
    ],
    ['F13.20', 'Sedative, hypnotic or anxiolytic dependence, uncomplicated'],
    ['F13.21', 'Sedative, hypnotic or anxiolytic dependence, in remission'],
    ['F13.230', 'Sedative, hypnotic or anxiolytic dependence with withdrawal, uncomplicated'],
    ['F13.239', 'Sedative, hypnotic or anxiolytic dependence with withdrawal, unspecified'],
    [
        'F13.24',
        'Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced mood disorder',
    ],
    [
        'F13.280',
        'Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced anxiety disorder',
    ],
    ['F13.90', 'Sedative, hypnotic, or anxiolytic use, unspecified, uncomplicated'],
    ['F13.91', 'Sedative, hypnotic or anxiolytic use, unspecified, in remission'],
    ['F13.930', 'Sedative, hypnotic or anxiolytic use, unspecified with withdrawal, uncomplicated'],
    [
        'F13.94',
        'Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced mood disorder',
    ],
    [
        'F13.980',
        'Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced anxiety disorder',
    ],
    ['F14.10', 'Cocaine abuse, uncomplicated'],
    ['F14.11', 'Cocaine abuse, in remission'],
    ['F14.13', 'Cocaine abuse, unspecified with withdrawal'],
    ['F14.14', 'Cocaine abuse with cocaine-induced mood disorder'],
    ['F14.159', 'Cocaine abuse with cocaine-induced psychotic disorder, unspecified'],
    ['F14.180', 'Cocaine abuse with cocaine-induced anxiety disorder'],
    ['F14.20', 'Cocaine dependence, uncomplicated'],
    ['F14.21', 'Cocaine dependence, in remission'],
    ['F14.23', 'Cocaine dependence with withdrawal'],
    ['F14.24', 'Cocaine dependence with cocaine-induced mood disorder'],
    ['F14.259', 'Cocaine dependence with cocaine-induced psychotic disorder, unspecified'],
    ['F14.280', 'Cocaine dependence with cocaine-induced anxiety disorder'],
    ['F14.90', 'Cocaine use, unspecified, uncomplicated'],
    ['F14.91', 'Cocaine use, unspecified, in remission'],
    ['F14.93', 'Cocaine use, unspecified with withdrawal'],
    ['F14.94', 'Cocaine use, unspecified with cocaine-induced mood disorder'],
    ['F14.959', 'Cocaine use, unspecified with cocaine-induced psychotic disorder, unspecified'],
    ['F14.980', 'Cocaine use, unspecified with cocaine-induced anxiety disorder'],
    ['F15.10', 'Other stimulant abuse, uncomplicated'],
    ['F15.11', 'Other stimulant abuse, in remission'],
    ['F15.13', 'Other stimulant abuse with withdrawal'],
    ['F15.14', 'Other stimulant abuse with stimulant-induced mood disorder'],
    ['F15.159', 'Other stimulant abuse with stimulant-induced psychotic disorder, unspecified'],
    ['F15.180', 'Other stimulant abuse with stimulant-induced anxiety disorder'],
    ['F15.20', 'Other stimulant dependence, uncomplicated'],
    ['F15.21', 'Other stimulant dependence, in remission'],
    ['F15.23', 'Other stimulant dependence with withdrawal'],
    ['F15.24', 'Other stimulant dependence with stimulant-induced mood disorder'],
    ['F15.259', 'Other stimulant dependence with stimulant-induced psychotic disorder, unspecified'],
    ['F15.280', 'Other stimulant dependence with stimulant-induced anxiety disorder'],
    ['F15.90', 'Other stimulant use, unspecified, uncomplicated'],
    ['F15.91', 'Other stimulant use, unspecified, in remission'],
    ['F15.93', 'Other stimulant use, unspecified with withdrawal'],
    ['F15.94', 'Other stimulant use, unspecified with stimulant-induced mood disorder'],
    [
        'F15.959',
        'Other stimulant use, unspecified with stimulant-induced psychotic disorder, unspecified',
    ],
    ['F15.980', 'Other stimulant use, unspecified with stimulant-induced anxiety disorder'],
    ['F16.10', 'Hallucinogen abuse, uncomplicated'],
    ['F16.11', 'Hallucinogen abuse, in remission'],
    ['F16.20', 'Hallucinogen dependence, uncomplicated'],
    ['F16.21', 'Hallucinogen dependence, in remission'],
    ['F16.90', 'Hallucinogen use, unspecified, uncomplicated'],
    ['F16.91', 'Hallucinogen use, unspecified, in remission'],
    [
        'F16.983',
        'Hallucinogen use, unspecified with hallucinogen persisting perception disorder (flashbacks)',
    ],
    ['F17.200', 'Nicotine dependence, unspecified, uncomplicated'],
    ['F17.201', 'Nicotine dependence, unspecified, in remission'],
    ['F17.203', 'Nicotine dependence unspecified, with withdrawal'],
    ['F17.208', 'Nicotine dependence, unspecified, with other nicotine-induced disorders'],
    ['F17.209', 'Nicotine dependence, unspecified, with unspecified nicotine-induced disorders'],
    ['F17.210', 'Nicotine dependence, cigarettes, uncomplicated'],
    ['F17.211', 'Nicotine dependence, cigarettes, in remission'],
    ['F17.213', 'Nicotine dependence, cigarettes, with withdrawal'],
    ['F17.218', 'Nicotine dependence, cigarettes, with other nicotine-induced disorders'],
    ['F17.219', 'Nicotine dependence, cigarettes, with unspecified nicotine-induced disorders'],
    ['F17.220', 'Nicotine dependence, chewing tobacco, uncomplicated'],
    ['F17.221', 'Nicotine dependence, chewing tobacco, in remission'],
    ['F17.223', 'Nicotine dependence, chewing tobacco, with withdrawal'],
    ['F17.228', 'Nicotine dependence, chewing tobacco, with other nicotine-induced disorders'],
    ['F17.229', 'Nicotine dependence, chewing tobacco, with unspecified nicotine-induced disorders'],
    ['F17.290', 'Nicotine dependence, other tobacco product, uncomplicated'],
    ['F17.291', 'Nicotine dependence, other tobacco product, in remission'],
    ['F17.293', 'Nicotine dependence, other tobacco product, with withdrawal'],
    ['F17.298', 'Nicotine dependence, other tobacco product, with other nicotine-induced disorders'],
    [
        'F17.299',
        'Nicotine dependence, other tobacco product, with unspecified nicotine-induced disorders',
    ],
    ['F18.10', 'Inhalant abuse, uncomplicated'],
    ['F18.11', 'Inhalant abuse, in remission'],
    ['F18.20', 'Inhalant dependence, uncomplicated'],
    ['F18.21', 'Inhalant dependence, in remission'],
    ['F18.90', 'Inhalant use, unspecified, uncomplicated'],
    ['F18.91', 'Inhalant use, unspecified, in remission'],
    ['F19.10', 'Other psychoactive substance abuse, uncomplicated'],
    ['F19.11', 'Other psychoactive substance abuse, in remission'],
    ['F19.130', 'Other psychoactive substance abuse with withdrawal, uncomplicated'],
    [
        'F19.14',
        'Other psychoactive substance abuse with psychoactive substance-induced mood disorder',
    ],
    [
        'F19.159',
        'Other psychoactive substance abuse with psychoactive substance-induced psychotic disorder, unspecified',
    ],
    [
        'F19.180',
        'Other psychoactive substance abuse with psychoactive substance-induced anxiety disorder',
    ],
    ['F19.20', 'Other psychoactive substance dependence, uncomplicated'],
    ['F19.21', 'Other psychoactive substance dependence, in remission'],
    ['F19.230', 'Other psychoactive substance dependence with withdrawal, uncomplicated'],
    ['F19.239', 'Other psychoactive substance dependence with withdrawal, unspecified'],
    [
        'F19.24',
        'Other psychoactive substance dependence with psychoactive substance-induced mood disorder',
    ],
    [
        'F19.259',
        'Other psychoactive substance dependence with psychoactive substance-induced psychotic disorder, unspecified',
    ],
    [
        'F19.280',
        'Other psychoactive substance dependence with psychoactive substance-induced anxiety disorder',
    ],
    ['F19.90', 'Other psychoactive substance use, unspecified, uncomplicated'],
    ['F19.91', 'Other psychoactive substance use, unspecified, in remission'],
    ['F19.930', 'Other psychoactive substance use, unspecified with withdrawal, uncomplicated'],
    [
        'F19.94',
        'Other psychoactive substance use, unspecified with psychoactive substance-induced mood disorder',
    ],
    [
        'F19.959',
        'Other psychoactive substance use, unspecified with psychoactive substance-induced psychotic disorder, unspecified',
    ],
    [
        'F19.980',
        'Other psychoactive substance use, unspecified with psychoactive substance-induced anxiety disorder',
    ],
    ['F20.0', 'Paranoid schizophrenia'],
    ['F20.1', 'Disorganized schizophrenia'],
    ['F20.2', 'Catatonic schizophrenia'],
    ['F20.3', 'Undifferentiated schizophrenia'],
    ['F20.5', 'Residual schizophrenia'],
    ['F20.81', 'Schizophreniform disorder'],
    ['F20.89', 'Other schizophrenia'],
    ['F20.9', 'Schizophrenia, unspecified'],
    ['F21', 'Schizotypal disorder'],
    ['F22', 'Delusional disorders'],
    ['F23', 'Brief psychotic disorder'],
    ['F24', 'Shared psychotic disorder'],
    ['F25.0', 'Schizoaffective disorder, bipolar type'],
    ['F25.1', 'Schizoaffective disorder, depressive type'],
    ['F25.8', 'Other schizoaffective disorders'],
    ['F25.9', 'Schizoaffective disorder, unspecified'],
    ['F28', 'Other psychotic disorder not due to a substance or known physiological condition'],
    ['F29', 'Unspecified psychosis not due to a substance or known physiological condition'],
    ['F30.10', 'Manic episode without psychotic symptoms, unspecified'],
    ['F30.11', 'Manic episode without psychotic symptoms, mild'],
    ['F30.12', 'Manic episode without psychotic symptoms, moderate'],
    ['F30.13', 'Manic episode, severe, without psychotic symptoms'],
    ['F30.2', 'Manic episode, severe with psychotic symptoms'],
    ['F30.3', 'Manic episode in partial remission'],
    ['F30.4', 'Manic episode in full remission'],
    ['F30.8', 'Other manic episodes'],
    ['F30.9', 'Manic episode, unspecified'],
    ['F31.0', 'Bipolar disorder, current episode hypomanic'],
    ['F31.10', 'Bipolar disorder, current episode manic without psychotic features, unspecified'],
    ['F31.11', 'Bipolar disorder, current episode manic without psychotic features, mild'],
    ['F31.12', 'Bipolar disorder, current episode manic without psychotic features, moderate'],
    ['F31.13', 'Bipolar disorder, current episode manic without psychotic features, severe'],
    ['F31.2', 'Bipolar disorder, current episode manic severe with psychotic features'],
    ['F31.30', 'Bipolar disorder, current episode depressed, mild or moderate severity, unspecified'],
    ['F31.31', 'Bipolar disorder, current episode depressed, mild'],
    ['F31.32', 'Bipolar disorder, current episode depressed, moderate'],
    ['F31.4', 'Bipolar disorder, current episode depressed, severe, without psychotic features'],
    ['F31.5', 'Bipolar disorder, current episode depressed, severe, with psychotic features'],
    ['F31.60', 'Bipolar disorder, current episode mixed, unspecified'],
    ['F31.61', 'Bipolar disorder, current episode mixed, mild'],
    ['F31.62', 'Bipolar disorder, current episode mixed, moderate'],
    ['F31.63', 'Bipolar disorder, current episode mixed, severe, without psychotic features'],
    ['F31.64', 'Bipolar disorder, current episode mixed, severe, with psychotic features'],
    ['F31.70', 'Bipolar disorder, currently in remission, most recent episode unspecified'],
    ['F31.71', 'Bipolar disorder, in partial remission, most recent episode hypomanic'],
    ['F31.72', 'Bipolar disorder, in full remission, most recent episode hypomanic'],
    ['F31.73', 'Bipolar disorder, in partial remission, most recent episode manic'],
    ['F31.74', 'Bipolar disorder, in full remission, most recent episode manic'],
    ['F31.75', 'Bipolar disorder, in partial remission, most recent episode depressed'],
    ['F31.76', 'Bipolar disorder, in full remission, most recent episode depressed'],
    ['F31.77', 'Bipolar disorder, in partial remission, most recent episode mixed'],
    ['F31.78', 'Bipolar disorder, in full remission, most recent episode mixed'],
    ['F31.81', 'Bipolar II disorder'],
    ['F31.89', 'Other bipolar disorder'],
    ['F31.9', 'Bipolar disorder, unspecified'],
    ['F32.0', 'Major depressive disorder, single episode, mild'],
    ['F32.1', 'Major depressive disorder, single episode, moderate'],
    ['F32.2', 'Major depressive disorder, single episode, severe without psychotic features'],
    ['F32.3', 'Major depressive disorder, single episode, severe with psychotic features'],
    ['F32.4', 'Major depressive disorder, single episode, in partial remission'],
    ['F32.5', 'Major depressive disorder, single episode, in full remission'],
    ['F32.81', 'Premenstrual dysphoric disorder'],
    ['F32.89', 'Other specified depressive episodes'],
    ['F32.9', 'Major depressive disorder, single episode, unspecified'],
    ['F32.A', 'Depression, unspecified'],
    ['F33.0', 'Major depressive disorder, recurrent, mild'],
    ['F33.1', 'Major depressive disorder, recurrent, moderate'],
    ['F33.2', 'Major depressive disorder, recurrent, severe without psychotic features'],
    ['F33.3', 'Major depressive disorder, recurrent, severe with psychotic symptoms'],
    ['F33.40', 'Major depressive disorder, recurrent, in remission, unspecified'],
    ['F33.41', 'Major depressive disorder, recurrent, in partial remission'],
    ['F33.42', 'Major depressive disorder, recurrent, in full remission'],
    ['F33.8', 'Other recurrent depressive disorders'],
    ['F33.9', 'Major depressive disorder, recurrent, unspecified'],
    ['F34.0', 'Cyclothymic disorder'],
    ['F34.1', 'Dysthymic disorder (persistent depressive disorder)'],
    ['F34.81', 'Disruptive mood dysregulation disorder'],
    ['F34.89', 'Other specified persistent mood disorders'],
    ['F34.9', 'Persistent mood [affective] disorder, unspecified'],
    ['F39', 'Unspecified mood [affective] disorder'],
    ['F40.00', 'Agoraphobia, unspecified'],
    ['F40.01', 'Agoraphobia with panic disorder'],
    ['F40.02', 'Agoraphobia without panic disorder'],
    ['F40.10', 'Social phobia, unspecified'],
    ['F40.11', 'Social phobia, generalized'],
    ['F40.210', 'Arachnophobia'],
    ['F40.218', 'Other animal type phobia'],
    ['F40.220', 'Fear of thunderstorms'],
    ['F40.228', 'Other natural environment type phobia'],
    ['F40.230', 'Fear of blood'],
    ['F40.231', 'Fear of injections and transfusions'],
    ['F40.232', 'Fear of other medical care'],
    ['F40.233', 'Fear of injury'],
    ['F40.240', 'Claustrophobia'],
    ['F40.241', 'Acrophobia'],
    ['F40.242', 'Fear of bridges'],
    ['F40.243', 'Fear of flying'],
    ['F40.248', 'Other situational type phobia'],
    ['F40.290', 'Androphobia'],
    ['F40.291', 'Gynephobia'],
    ['F40.298', 'Other specified phobia'],
    ['F40.8', 'Other phobic anxiety disorders'],
    ['F40.9', 'Phobic anxiety disorder, unspecified'],
    ['F41.0', 'Panic disorder without agoraphobia'],
    ['F41.1', 'Generalized anxiety disorder'],
    ['F41.3', 'Other mixed anxiety disorders'],
    ['F41.8', 'Other specified anxiety disorders'],
    ['F41.9', 'Anxiety disorder, unspecified'],
    ['F42.2', 'Mixed obsessional thoughts and acts'],
    ['F42.3', 'Hoarding disorder'],
    ['F42.4', 'Excoriation (skin-picking) disorder'],
    ['F42.8', 'Other obsessive-compulsive disorder'],
    ['F42.9', 'Obsessive-compulsive disorder, unspecified'],
    ['F43.0', 'Acute stress reaction'],
    ['F43.10', 'Post-traumatic stress disorder, unspecified'],
    ['F43.11', 'Post-traumatic stress disorder, acute'],
    ['F43.12', 'Post-traumatic stress disorder, chronic'],
    ['F43.20', 'Adjustment disorder, unspecified'],
    ['F43.21', 'Adjustment disorder with depressed mood'],
    ['F43.22', 'Adjustment disorder with anxiety'],
    ['F43.23', 'Adjustment disorder with mixed anxiety and depressed mood'],
    ['F43.24', 'Adjustment disorder with disturbance of conduct'],
    ['F43.25', 'Adjustment disorder with mixed disturbance of emotions and conduct'],
    ['F43.29', 'Adjustment disorder with other symptoms'],
    ['F43.81', 'Prolonged grief disorder'],
    ['F43.89', 'Other reactions to severe stress'],
    ['F43.9', 'Reaction to severe stress, unspecified'],
    ['F44.0', 'Dissociative amnesia'],
    ['F44.1', 'Dissociative fugue'],
    ['F44.2', 'Dissociative stupor'],
    ['F44.4', 'Conversion disorder with motor symptom or deficit'],
    ['F44.5', 'Conversion disorder with seizures or convulsions'],
    ['F44.6', 'Conversion disorder with sensory symptom or deficit'],
    ['F44.7', 'Conversion disorder with mixed symptom presentation'],
    ['F44.81', 'Dissociative identity disorder'],
    ['F44.89', 'Other dissociative and conversion disorders'],
    ['F44.9', 'Dissociative and conversion disorder, unspecified'],
    ['F45.0', 'Somatization disorder'],
    ['F45.1', 'Somatization / somatic symptom disorder'],
    ['F45.20', 'Hypochondriacal disorder, unspecified'],
    ['F45.21', 'Hypochondriasis / illness anxiety disorder'],
    ['F45.22', 'Body dysmorphic disorder'],
    ['F45.29', 'Other hypochondriacal disorders'],
    ['F45.41', 'Pain disorder exclusively related to psychological factors'],
    ['F45.42', 'Pain disorder with related psychological factors'],
    ['F45.8', 'Other somatoform disorders'],
    ['F45.9', 'Somatoform disorder, unspecified'],
    ['F48.1', 'Depersonalization-derealization syndrome'],
    ['F48.2', 'Pseudobulbar affect'],
    ['F48.8', 'Other specified nonpsychotic mental disorders'],
    ['F48.9', 'Nonpsychotic mental disorder, unspecified'],
    ['F50.00', 'Anorexia nervosa, unspecified'],
    ['F50.010', 'Anorexia nervosa, restricting type, mild'],
    ['F50.011', 'Anorexia nervosa, restricting type, moderate'],
    ['F50.012', 'Anorexia nervosa, restricting type, severe'],
    ['F50.013', 'Anorexia nervosa, restricting type, extreme'],
    ['F50.014', 'Anorexia nervosa, restricting type, in remission'],
    ['F50.019', 'Anorexia nervosa, restricting type, unspecified'],
    ['F50.020', 'Anorexia nervosa, binge eating/purging type, mild'],
    ['F50.021', 'Anorexia nervosa, binge eating/purging type, moderate'],
    ['F50.022', 'Anorexia nervosa, binge eating/purging type, severe'],
    ['F50.023', 'Anorexia nervosa, binge eating/purging type, extreme'],
    ['F50.024', 'Anorexia nervosa, binge eating/purging type, in remission'],
    ['F50.029', 'Anorexia nervosa, binge eating/purging type, unspecified'],
    ['F50.20', 'Bulimia nervosa, unspecified'],
    ['F50.21', 'Bulimia nervosa, mild'],
    ['F50.22', 'Bulimia nervosa, moderate'],
    ['F50.23', 'Bulimia nervosa, severe'],
    ['F50.24', 'Bulimia nervosa, extreme'],
    ['F50.25', 'Bulimia nervosa, in remission'],
    ['F50.810', 'Binge eating disorder, mild'],
    ['F50.811', 'Binge eating disorder, moderate'],
    ['F50.812', 'Binge eating disorder, severe'],
    ['F50.813', 'Binge eating disorder, extreme'],
    ['F50.814', 'Binge eating disorder, in remission'],
    ['F50.819', 'Binge eating disorder, unspecified'],
    ['F50.82', 'Avoidant/restrictive food intake disorder'],
    ['F50.83', 'Pica in adults'],
    ['F50.84', 'Rumination disorder in adults'],
    ['F50.89', 'Other specified eating disorder'],
    ['F50.9', 'Eating disorder, unspecified'],
    ['F51.01', 'Primary insomnia'],
    ['F51.02', 'Adjustment insomnia'],
    ['F51.03', 'Paradoxical insomnia'],
    ['F51.04', 'Psychophysiologic insomnia'],
    ['F51.05', 'Insomnia due to other mental disorder'],
    ['F51.09', 'Other insomnia not due to a substance or known physiological condition'],
    ['F51.11', 'Primary hypersomnia'],
    ['F51.12', 'Insufficient sleep syndrome'],
    ['F51.13', 'Hypersomnia due to other mental disorder'],
    ['F51.19', 'Other hypersomnia not due to a substance or known physiological condition'],
    ['F51.3', 'Sleepwalking [somnambulism]'],
    ['F51.4', 'Sleep terrors [night terrors]'],
    ['F51.5', 'Nightmare disorder'],
    ['F51.8', 'Other sleep disorders not due to a substance or known physiological condition'],
    ['F51.9', 'Sleep disorder not due to a substance or known physiological condition, unspecified'],
    ['F52.0', 'Hypoactive sexual desire disorder'],
    ['F52.1', 'Sexual aversion disorder'],
    ['F52.21', 'Male erectile disorder'],
    ['F52.22', 'Female sexual arousal disorder'],
    ['F52.31', 'Female orgasmic disorder'],
    ['F52.32', 'Male orgasmic disorder'],
    ['F52.4', 'Premature ejaculation'],
    ['F52.5', 'Vaginismus not due to a substance or known physiological condition'],
    ['F52.6', 'Dyspareunia not due to a substance or known physiological condition'],
    ['F52.8', 'Other sexual dysfunction not due to a substance or known physiological condition'],
    [
        'F52.9',
        'Unspecified sexual dysfunction not due to a substance or known physiological condition',
    ],
    ['F53.0', 'Postpartum depression'],
    ['F53.1', 'Puerperal psychosis'],
    [
        'F54',
        'Psychological and behavioral factors associated with disorders or diseases classified elsewhere',
    ],
    ['F55.0', 'Abuse of antacids'],
    ['F55.1', 'Abuse of herbal or folk remedies'],
    ['F55.2', 'Abuse of laxatives'],
    ['F55.3', 'Abuse of steroids or hormones'],
    ['F55.4', 'Abuse of vitamins'],
    ['F55.8', 'Abuse of other non-psychoactive substances'],
    [
        'F59',
        'Unspecified behavioral syndromes associated with physiological disturbances and physical factors',
    ],
    ['F60.0', 'Paranoid personality disorder'],
    ['F60.1', 'Schizoid personality disorder'],
    ['F60.2', 'Antisocial personality disorder'],
    ['F60.3', 'Borderline personality disorder'],
    ['F60.4', 'Histrionic personality disorder'],
    ['F60.5', 'Obsessive-compulsive personality disorder'],
    ['F60.6', 'Avoidant personality disorder'],
    ['F60.7', 'Dependent personality disorder'],
    ['F60.81', 'Narcissistic personality disorder'],
    ['F60.89', 'Other specific personality disorders'],
    ['F60.9', 'Personality disorder, unspecified'],
    ['F63.0', 'Pathological gambling'],
    ['F63.1', 'Pyromania'],
    ['F63.2', 'Kleptomania'],
    ['F63.3', 'Trichotillomania'],
    ['F63.81', 'Intermittent explosive disorder'],
    ['F63.89', 'Other impulse disorders'],
    ['F63.9', 'Impulse disorder, unspecified'],
    ['F64.0', 'Gender dysphoria in adolescents and adults'],
    ['F64.1', 'Dual role transvestism'],
    ['F64.2', 'Gender identity disorder of childhood'],
    ['F64.8', 'Other gender identity disorders'],
    ['F64.9', 'Gender identity disorder, unspecified'],
    ['F65.0', 'Fetishism'],
    ['F65.1', 'Transvestic fetishism'],
    ['F65.2', 'Exhibitionism'],
    ['F65.3', 'Voyeurism'],
    ['F65.4', 'Pedophilia'],
    ['F65.50', 'Sadomasochism, unspecified'],
    ['F65.51', 'Sexual masochism'],
    ['F65.52', 'Sexual sadism'],
    ['F65.81', 'Frotteurism'],
    ['F65.89', 'Other paraphilias'],
    ['F65.9', 'Paraphilia, unspecified'],
    ['F66', 'Other sexual disorders'],
    ['F68.10', 'Factitious disorder imposed on self'],
    [
        'F68.11',
        'Factitious disorder imposed on self, with predominantly psychological signs and symptoms',
    ],
    ['F68.12', 'Factitious disorder imposed on self, with predominantly physical signs and symptoms'],
    [
        'F68.13',
        'Factitious disorder imposed on self, with combined psychological and physical signs and symptoms',
    ],
    ['F68.8', 'Other specified disorders of adult personality and behavior'],
    ['F68.A', 'Factitious disorder imposed on another'],
    ['F69', 'Unspecified disorder of adult personality and behavior'],
    ['F70', 'Mild intellectual disabilities'],
    ['F71', 'Moderate intellectual disabilities'],
    ['F72', 'Severe intellectual disabilities'],
    ['F73', 'Profound intellectual disabilities'],
    ['F78.A1', 'SYNGAP1-related intellectual disability'],
    ['F78.A9', 'Other genetic related intellectual disability'],
    ['F79', 'Unspecified intellectual disabilities'],
    ['F80.0', 'Phonological disorder'],
    ['F80.1', 'Expressive language disorder'],
    ['F80.2', 'Mixed receptive-expressive language disorder'],
    ['F80.4', 'Speech and language development delay due to hearing loss'],
    ['F80.81', 'Childhood onset fluency disorder (stuttering)'],
    ['F80.82', 'Social pragmatic communication disorder'],
    ['F80.89', 'Other developmental disorders of speech and language'],
    ['F80.9', 'Developmental disorder of speech and language, unspecified'],
    ['F81.0', 'Specific reading disorder'],
    ['F81.2', 'Mathematics disorder'],
    ['F81.81', 'Disorder of written expression'],
    ['F81.89', 'Other developmental disorders of scholastic skills'],
    ['F81.9', 'Developmental disorder of scholastic skills, unspecified'],
    ['F82', 'Specific developmental disorder of motor function'],
    ['F84.0', 'Autistic disorder'],
    ['F84.2', "Rett\\'s syndrome"],
    ['F84.3', 'Other childhood disintegrative disorder'],
    ['F84.5', 'Asperger syndrome'],
    ['F84.8', 'Other pervasive developmental disorders'],
    ['F84.9', 'Pervasive developmental disorder, unspecified'],
    ['F88', 'Other disorders of psychological development'],
    ['F89', 'Unspecified disorder of psychological development'],
    ['F90.0', 'ADHD, predominantly inattentive type'],
    ['F90.1', 'ADHD, predominantly hyperactive type'],
    ['F90.2', 'ADHD, combined type'],
    ['F90.8', 'ADHD, other type'],
    ['F90.9', 'ADHD, unspecified type'],
    ['F91.0', 'Conduct disorder confined to family context'],
    ['F91.1', 'Conduct disorder, childhood-onset type'],
    ['F91.2', 'Conduct disorder, adolescent-onset type'],
    ['F91.3', 'Oppositional defiant disorder'],
    ['F91.8', 'Other conduct disorders'],
    ['F91.9', 'Conduct disorder, unspecified'],
    ['F93.0', 'Separation anxiety disorder of childhood'],
    ['F93.8', 'Other childhood emotional disorders'],
    ['F93.9', 'Childhood emotional disorder, unspecified'],
    ['F94.0', 'Selective mutism'],
    ['F94.1', 'Reactive attachment disorder of childhood'],
    ['F94.2', 'Disinhibited attachment disorder of childhood'],
    ['F94.8', 'Other childhood disorders of social functioning'],
    ['F94.9', 'Childhood disorder of social functioning, unspecified'],
    ['F95.0', 'Transient tic disorder'],
    ['F95.1', 'Chronic motor or vocal tic disorder'],
    ['F95.2', 'Tourette disorder'],
    ['F95.8', 'Other tic disorders'],
    ['F95.9', 'Tic disorder, unspecified'],
    ['F98.0', 'Enuresis not due to a substance or known physiological condition'],
    ['F98.1', 'Encopresis not due to a substance or known physiological condition'],
    ['F98.21', 'Rumination disorder of infancy and childhood'],
    ['F98.29', 'Other feeding disorders of infancy and early childhood'],
    ['F98.3', 'Pica of infancy and childhood'],
    ['F98.4', 'Stereotyped movement disorders'],
    ['F98.5', 'Adult onset fluency disorder'],
    [
        'F98.8',
        'Other specified behavioral and emotional disorders with onset usually occurring in childhood and adolescence',
    ],
    [
        'F98.9',
        'Unspecified behavioral and emotional disorders with onset usually occurring in childhood and adolescence',
    ],
    ['F99', 'Mental disorder, not otherwise specified'],
    ['G25.81', 'Restless legs syndrome'],
    ['G30.0', "Alzheimer\\'s disease with early onset"],
    ['G30.1', "Alzheimer\\'s disease with late onset"],
    ['G30.8', "Other Alzheimer\\'s disease"],
    ['G30.9', "Alzheimer\\'s disease, unspecified"],
    ['G31.84', 'Mild cognitive impairment of uncertain or unknown etiology'],
    ['G47.00', 'Insomnia, unspecified'],
    ['G47.01', 'Insomnia due to medical condition'],
    ['G47.09', 'Other insomnia'],
    ['G47.10', 'Hypersomnia, unspecified'],
    ['G47.20', 'Circadian rhythm sleep disorder, unspecified type'],
    ['G47.21', 'Circadian rhythm sleep disorder, delayed sleep phase type'],
    ['G47.23', 'Circadian rhythm sleep disorder, irregular sleep wake type'],
    ['G47.26', 'Circadian rhythm sleep disorder, shift work type'],
    ['G47.33', 'Obstructive sleep apnea (adult) (pediatric)'],
    ['G47.411', 'Narcolepsy with cataplexy'],
    ['G47.419', 'Narcolepsy without cataplexy'],
    ['G47.52', 'REM sleep behavior disorder'],
    ['G47.9', 'Sleep disorder, unspecified'],
    ['N46.9', 'Male infertility, unspecified'],
    ['N97.9', 'Female infertility, unspecified'],
    ['R41.81', 'Age-related cognitive decline'],
    ['R41.82', 'Altered mental status, unspecified'],
    ['R41.83', 'Borderline intellectual functioning'],
    ['R41.840', 'Attention and concentration deficit'],
    ['R41.841', 'Cognitive communication deficit'],
    ['R41.842', 'Visuospatial deficit'],
    ['R41.843', 'Psychomotor deficit'],
    ['R41.844', 'Frontal lobe and executive function deficit'],
    ['R41.85', 'Anosognosia'],
    ['R41.89', 'Other symptoms and signs involving cognitive functions and awareness'],
    ['R45.0', 'Nervousness'],
    ['R45.1', 'Restlessness and agitation'],
    ['R45.2', 'Unhappiness'],
    ['R45.3', 'Demoralization and apathy'],
    ['R45.4', 'Irritability and anger'],
    ['R45.5', 'Hostility'],
    ['R45.6', 'Violent behavior'],
    ['R45.7', 'State of emotional shock and stress, unspecified'],
    ['R45.81', 'Low self-esteem'],
    ['R45.82', 'Worries'],
    ['R45.83', 'Excessive crying of child, adolescent or adult'],
    ['R45.84', 'Anhedonia'],
    ['R45.850', 'Homicidal ideations'],
    ['R45.851', 'Suicidal ideations'],
    ['R45.86', 'Emotional lability'],
    ['R45.87', 'Impulsiveness'],
    ['R45.88', 'Nonsuicidal self-harm'],
    ['R45.89', 'Other symptoms and signs involving emotional state'],
    ['T74.01XA', 'Adult neglect or abandonment, confirmed, initial encounter'],
    ['T74.02XA', 'Child neglect or abandonment, confirmed, initial encounter'],
    ['T74.11XA', 'Adult physical abuse, confirmed, initial encounter'],
    ['T74.12XA', 'Child physical abuse, confirmed, initial encounter'],
    ['T74.21XA', 'Adult sexual abuse, confirmed, initial encounter'],
    ['T74.22XA', 'Child sexual abuse, confirmed, initial encounter'],
    ['T74.31XA', 'Adult psychological abuse, confirmed, initial encounter'],
    ['T74.32XA', 'Child psychological abuse, confirmed, initial encounter'],
    ['T74.4XXA', 'Shaken infant syndrome, initial encounter'],
    ['T74.51XA', 'Adult forced sexual exploitation, confirmed, initial encounter'],
    ['T74.52XA', 'Child sexual exploitation, confirmed, initial encounter'],
    ['T74.61XA', 'Adult forced labor exploitation, confirmed, initial encounter'],
    ['T74.62XA', 'Child forced labor exploitation, confirmed, initial encounter'],
    ['T74.91XA', 'Unspecified adult maltreatment, confirmed, initial encounter'],
    ['T74.92XA', 'Unspecified child maltreatment, confirmed, initial encounter'],
    ['T74.A1XA', 'Adult financial abuse, confirmed, initial encounter'],
    ['T74.A2XA', 'Child financial abuse, confirmed, initial encounter'],
    ['T76.01XA', 'Adult neglect or abandonment, suspected, initial encounter'],
    ['T76.02XA', 'Child neglect or abandonment, suspected, initial encounter'],
    ['T76.11XA', 'Adult physical abuse, suspected, initial encounter'],
    ['T76.12XA', 'Child physical abuse, suspected, initial encounter'],
    ['T76.21XA', 'Adult sexual abuse, suspected, initial encounter'],
    ['T76.22XA', 'Child sexual abuse, suspected, initial encounter'],
    ['T76.31XA', 'Adult psychological abuse, suspected, initial encounter'],
    ['T76.32XA', 'Child psychological abuse, suspected, initial encounter'],
    ['T76.51XA', 'Adult forced sexual exploitation, suspected, initial encounter'],
    ['T76.52XA', 'Child sexual exploitation, suspected, initial encounter'],
    ['T76.61XA', 'Adult forced labor exploitation, suspected, initial encounter'],
    ['T76.62XA', 'Child forced labor exploitation, suspected, initial encounter'],
    ['T76.91XA', 'Unspecified adult maltreatment, suspected, initial encounter'],
    ['T76.92XA', 'Unspecified child maltreatment, suspected, initial encounter'],
    ['T76.A1XA', 'Adult financial abuse, suspected, initial encounter'],
    ['T76.A2XA', 'Child financial abuse, suspected, initial encounter'],
    ['Z55.0', 'Illiteracy and low-level literacy'],
    ['Z55.1', 'Schooling unavailable and unattainable'],
    ['Z55.2', 'Failed school examinations'],
    ['Z55.3', 'Underachievement in school'],
    ['Z55.4', 'Educational maladjustment and discord with teachers and classmates'],
    ['Z55.5', 'Less than a high school diploma'],
    ['Z55.6', 'Problems related to health literacy'],
    ['Z55.8', 'Other problems related to education and literacy'],
    ['Z55.9', 'Problems related to education and literacy, unspecified'],
    ['Z56.0', 'Unemployment, unspecified'],
    ['Z56.1', 'Change of job'],
    ['Z56.2', 'Threat of job loss'],
    ['Z56.3', 'Stressful work schedule'],
    ['Z56.4', 'Discord with boss and workmates'],
    ['Z56.5', 'Uncongenial work environment'],
    ['Z56.6', 'Other physical and mental strain related to work'],
    ['Z56.81', 'Sexual harassment on the job'],
    ['Z56.82', 'Military deployment status'],
    ['Z56.89', 'Other problems related to employment'],
    ['Z56.9', 'Unspecified problems related to employment'],
    ['Z59.00', 'Homelessness, unspecified'],
    ['Z59.01', 'Sheltered homelessness'],
    ['Z59.02', 'Unsheltered homelessness'],
    ['Z59.10', 'Inadequate housing, unspecified'],
    ['Z59.11', 'Inadequate housing environmental temperature'],
    ['Z59.12', 'Inadequate housing utilities'],
    ['Z59.19', 'Other inadequate housing'],
    ['Z59.2', 'Discord with neighbors, lodgers and landlord'],
    ['Z59.3', 'Problems related to living in residential institution'],
    ['Z59.41', 'Food insecurity'],
    ['Z59.48', 'Other specified lack of adequate food'],
    ['Z59.5', 'Extreme poverty'],
    ['Z59.6', 'Low income'],
    ['Z59.71', 'Insufficient health insurance coverage'],
    ['Z59.72', 'Insufficient welfare support'],
    ['Z59.811', 'Housing instability, housed, with risk of homelessness'],
    ['Z59.812', 'Housing instability, housed, homelessness in past 12 months'],
    ['Z59.819', 'Housing instability, housed unspecified'],
    ['Z59.82', 'Transportation insecurity'],
    ['Z59.861', 'Financial insecurity, difficulty paying for utilities'],
    ['Z59.868', 'Other specified financial insecurity'],
    ['Z59.869', 'Financial insecurity, unspecified'],
    ['Z59.87', 'Material hardship due to limited financial resources, not elsewhere classified'],
    ['Z59.89', 'Other problems related to housing and economic circumstances'],
    ['Z59.9', 'Problem related to housing and economic circumstances, unspecified'],
    ['Z60.0', 'Problems of adjustment to life-cycle transitions'],
    ['Z60.2', 'Problems related to living alone'],
    ['Z60.3', 'Acculturation difficulty'],
    ['Z60.4', 'Social exclusion and rejection'],
    ['Z60.5', 'Target of (perceived) adverse discrimination and persecution'],
    ['Z60.8', 'Other problems related to social environment'],
    ['Z60.9', 'Problem related to social environment, unspecified'],
    ['Z62.0', 'Inadequate parental supervision and control'],
    ['Z62.1', 'Parental overprotection'],
    ['Z62.21', 'Child in welfare custody'],
    ['Z62.22', 'Institutional upbringing'],
    ['Z62.23', 'Child in custody of non-parental relative'],
    ['Z62.24', 'Child in custody of non-relative guardian'],
    ['Z62.29', 'Other upbringing away from parents'],
    ['Z62.3', 'Hostility towards and scapegoating of child'],
    ['Z62.6', 'Inappropriate (excessive) parental pressure'],
    ['Z62.810', 'Personal history of physical and sexual abuse in childhood'],
    ['Z62.811', 'Personal history of psychological abuse in childhood'],
    ['Z62.812', 'Personal history of neglect in childhood'],
    ['Z62.813', 'Personal history of forced labor or sexual exploitation in childhood'],
    ['Z62.814', 'Personal history of child financial abuse'],
    ['Z62.815', 'Personal history of intimate partner abuse in childhood'],
    ['Z62.819', 'Personal history of unspecified abuse in childhood'],
    ['Z62.820', 'Parent-child conflict'],
    ['Z62.821', 'Parent-adopted child conflict'],
    ['Z62.822', 'Parent-foster child conflict'],
    ['Z62.823', 'Parent-step child conflict'],
    ['Z62.831', 'Non-parental relative-child conflict'],
    ['Z62.832', 'Non-relative guardian-child conflict'],
    ['Z62.833', 'Group home staff-child conflict'],
    ['Z62.890', 'Parent-child estrangement NEC'],
    ['Z62.891', 'Sibling rivalry'],
    ['Z62.892', 'Runaway [from current living environment]'],
    ['Z62.898', 'Other specified problems related to upbringing'],
    ['Z62.9', 'Problem related to upbringing, unspecified'],
    ['Z63.0', 'Problems in relationship with spouse or partner'],
    ['Z63.1', 'Problems in relationship with in-laws'],
    ['Z63.31', 'Absence of family member due to military deployment'],
    ['Z63.32', 'Other absence of family member'],
    ['Z63.4', 'Disappearance and death of family member'],
    ['Z63.5', 'Disruption of family by separation and divorce'],
    ['Z63.6', 'Dependent relative needing care at home'],
    ['Z63.71', 'Stress on family due to return of family member from military deployment'],
    ['Z63.72', 'Alcoholism and drug addiction in family'],
    ['Z63.79', 'Other stressful life events affecting family and household'],
    ['Z63.8', 'Other specified problems related to primary support group'],
    ['Z63.9', 'Problem related to primary support group, unspecified'],
    ['Z64.0', 'Problems related to unwanted pregnancy'],
    ['Z64.1', 'Problems related to multiparity'],
    ['Z64.4', 'Discord with counselors'],
    ['Z65.0', 'Conviction in civil and criminal proceedings without imprisonment'],
    ['Z65.1', 'Imprisonment and other incarceration'],
    ['Z65.2', 'Problems related to release from prison'],
    ['Z65.3', 'Problems related to other legal circumstances'],
    ['Z65.4', 'Victim of crime and terrorism'],
    ['Z65.5', 'Exposure to disaster, war and other hostilities'],
    ['Z65.8', 'Other specified problems related to psychosocial circumstances'],
    ['Z65.9', 'Problem related to unspecified psychosocial circumstances'],
    ['Z69.010', 'Encounter for mental health services for victim of parental child abuse'],
    ['Z69.011', 'Encounter for mental health services for perpetrator of parental child abuse'],
    ['Z69.020', 'Encounter for mental health services for victim of non-parental child abuse'],
    ['Z69.021', 'Encounter for mental health services for perpetrator of non-parental child abuse'],
    ['Z69.11', 'Encounter for mental health services for victim of spousal or partner abuse'],
    ['Z69.12', 'Encounter for mental health services for perpetrator of spousal or partner abuse'],
    ['Z69.81', 'Encounter for mental health services for victim of other abuse'],
    ['Z69.82', 'Encounter for mental health services for perpetrator of other abuse'],
    ['Z71.41', 'Alcohol abuse counseling and surveillance of alcoholic'],
    ['Z71.42', 'Counseling for family member of alcoholic'],
    ['Z71.51', 'Drug abuse counseling and surveillance of drug abuser'],
    ['Z71.52', 'Counseling for family member of drug abuser'],
    ['Z71.6', 'Tobacco abuse counseling'],
    ['Z71.89', 'Other specified counseling'],
    ['Z71.9', 'Counseling, unspecified'],
    ['Z72.0', 'Tobacco use'],
    ['Z72.3', 'Lack of physical exercise'],
    ['Z72.4', 'Inappropriate diet and eating habits'],
    ['Z72.51', 'High risk heterosexual behavior'],
    ['Z72.52', 'High risk homosexual behavior'],
    ['Z72.53', 'High risk bisexual behavior'],
    ['Z72.6', 'Gambling and betting'],
    ['Z72.810', 'Child and adolescent antisocial behavior'],
    ['Z72.811', 'Adult antisocial behavior'],
    ['Z72.820', 'Sleep deprivation'],
    ['Z72.821', 'Inadequate sleep hygiene'],
    ['Z72.823', 'Risk of suffocation (smothering) under another while sleeping'],
    ['Z72.89', 'Other problems related to lifestyle'],
    ['Z72.9', 'Problem related to lifestyle, unspecified'],
    ['Z73.0', 'Burn-out'],
    ['Z73.1', 'Type A behavior pattern'],
    ['Z73.2', 'Lack of relaxation and leisure'],
    ['Z73.3', 'Stress, not elsewhere classified'],
    ['Z73.4', 'Inadequate social skills, not elsewhere classified'],
    ['Z73.5', 'Social role conflict, not elsewhere classified'],
    ['Z73.6', 'Limitation of activities due to disability'],
    ['Z73.810', 'Behavioral insomnia of childhood, sleep-onset association type'],
    ['Z73.811', 'Behavioral insomnia of childhood, limit setting type'],
    ['Z73.812', 'Behavioral insomnia of childhood, combined type'],
    ['Z73.819', 'Behavioral insomnia of childhood, unspecified type'],
    ['Z73.82', 'Dual sensory impairment'],
    ['Z73.89', 'Other problems related to life management difficulty'],
    ['Z73.9', 'Problem related to life management difficulty, unspecified'],
    ['Z87.59', 'Personal history of other complications of pregnancy, childbirth and the puerperium'],
    ['Z87.820', 'Personal history of traumatic brain injury'],
    ['Z91.120', "Patient's intentional underdosing of medication regimen due to financial hardship"],
    ['Z91.128', "Patient's intentional underdosing of medication regimen for other reason"],
    [
        'Z91.130',
        "Patient's unintentional underdosing of medication regimen due to age-related debility",
    ],
    ['Z91.138', "Patient's unintentional underdosing of medication regimen for other reason"],
    ['Z91.141', "Patient's other noncompliance with medication regimen due to financial hardship"],
    ['Z91.148', "Patient's other noncompliance with medication regimen for other reason"],
    [
        'Z91.190',
        "Patient's noncompliance with other medical treatment and regimen due to financial hardship",
    ],
    ['Z91.198', "Patient's noncompliance with other medical treatment and regimen for other reason"],
    [
        'Z91.199',
        "Patient's noncompliance with other medical treatment and regimen due to unspecified reason",
    ],
    ['Z91.410', 'Personal history of adult physical and sexual abuse'],
    ['Z91.411', 'Personal history of adult psychological abuse'],
    ['Z91.412', 'Personal history of adult neglect'],
    ['Z91.413', 'Personal history of adult financial abuse'],
    ['Z91.414', 'Personal history of adult intimate partner abuse'],
    ['Z91.419', 'Personal history of unspecified adult abuse'],
    ['Z91.42', 'Personal history of forced labor or sexual exploitation'],
    ['Z91.49', 'Other personal history of psychological trauma, not elsewhere classified'],
    ['Z91.51', 'Personal history of suicidal behavior'],
    ['Z91.52', 'Personal history of nonsuicidal self-harm'],
    ['Z91.82', 'Personal history of military deployment'],
    [
        'Z91.A20',
        "Caregiver's intentional underdosing of patient's medication regimen due to financial hardship",
    ],
    ['Z91.A28', "Caregiver's intentional underdosing of medication regimen for other reason"],
    ['Z91.A3', "Caregiver's unintentional underdosing of patient's medication regimen"],
    [
        'Z91.A41',
        "Caregiver's other noncompliance with patient's medication regimen due to financial hardship",
    ],
    ['Z91.A48', "Caregiver's other noncompliance with patient's medication regimen for other reason"],
];
//# sourceMappingURL=icd10Catalog.js.map